import React from 'react';
import { number } from 'prop-types';

// Components
import { Box, Divider, Skeleton } from '@mui/material';
import './Skeleton.css';

const SelectorSkeleton = ({ skeletonHeight }) => {
  return (
    <>
      <div className="selector-skeleton" data-testid="skeleton" height={skeletonHeight}>
        <Skeleton classes={{ root: 'title' }} height={25} variant="rectangular" />
        <Box alignItems="center" display="flex">
          <Skeleton classes={{ root: 'count' }} height={25} variant="rectangular" />
          <Skeleton classes={{ root: 'text' }} height={18} variant="rectangular" />
        </Box>
        <Box alignItems="center" display="flex">
          <Skeleton classes={{ root: 'count' }} height={25} variant="rectangular" />
          <Skeleton classes={{ root: 'text' }} height={18} variant="rectangular" />
        </Box>
      </div>
      <Divider />
    </>
  );
};

SelectorSkeleton.propTypes = {
  skeletonHeight: number.isRequired,
};

export default SelectorSkeleton;
